import { isMobile } from 'react-device-detect';
import { Navigate } from 'react-router-dom';

import { useIsManager } from '~modules/auth/model';
import { SessionList } from '~pages/manager/SessionList/SessionList.tsx';
import { Notmobile } from '~pages/manager/notmobile.tsx';
import { routerKeys } from '~shared/router';
import { ToolbarBtn } from '~shared/ui';

export function ListPage() {
	const isManager = useIsManager();

	if (!isManager) return <Navigate to={routerKeys.denied()} />;
	if (!isMobile) return <Notmobile />;

	return (
		<div className="cabinet-sessions">
			<h1>Список смен</h1>
			<SessionList />
			<ToolbarBtn to={routerKeys.manager.add()} title="Создать" icon1="plus_white" />
		</div>
	);
}
